import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import NegotiationState from '../../../../_shared/constants/negotiationState';
import KebabMenuSeller from '../../../TradeCard/PendingTradeCardContent/KebabMenuSeller';
import ReducerConstants from '../../../../_shared/constants/reducers';
import TradeDetails from '../../../../_shared/models/TradeDetails';
import useAuctionNegotiation from '../../../../_shared/hooks/trade/useAuctionNegotiation';
import PendingFooterButton from './PendingFooterButton';
import PendingFooterContext from './PendingFooterContext';
import { getNegotiationState } from '../../../../_shared/models/NegotiationList';
import { StyledKebabLabel, StyledKebabWrapper } from './Styles';
import { StyledOverviewFooter } from '../Styles';

const PendingFooter = ({ tradeDetails, isOmp }) => {
  const [negotiationState, setNegotiationState] = useState(null);
  const [network, setNetwork] = useState(null);
  const [pendingFooterContext, setPendingFooterContext] = useState({
    negotiations: null,
    negotiationState: null
  });

  const [sellingNetworks] = useSelector(
    state => [
      state[ReducerConstants.AUTH]?.user?.auctionSource?.sellingNetworks
    ],
    shallowEqual
  );

  const negotiations = useAuctionNegotiation(
    tradeDetails?.auctionSummary?.id,
    TradeDetails.canNegotiate(tradeDetails)
  );

  // Set network after sellingNetworks is done loading
  useEffect(() => {
    if (sellingNetworks) {
      setNetwork(
        sellingNetworks.find(
          ({ id }) => id === tradeDetails?.dealer?.network?.id
        )
      );
    }
  }, [sellingNetworks, tradeDetails?.dealer?.network?.id]);

  // Set negotiationState after negotiations is done loading
  useEffect(() => {
    if (negotiations) {
      setNegotiationState(getNegotiationState(negotiations));
    } else if (!TradeDetails.canNegotiate(tradeDetails)) {
      setNegotiationState(
        TradeDetails.getNegotiationState(tradeDetails, false)
      );
    }
  }, [tradeDetails, negotiations]);

  // Set context after negotiations and negotiationState are set
  // (avoids premature re-rendering)
  useEffect(() => {
    if (negotiationState) {
      setPendingFooterContext({ negotiations, negotiationState });
    }
  }, [negotiations, negotiationState]);

  return (
    <StyledOverviewFooter>
      <PendingFooterContext.Provider value={pendingFooterContext}>
        <PendingFooterButton tradeDetails={tradeDetails} isOmp={isOmp} />
        <StyledKebabWrapper>
          <StyledKebabLabel>
            <FormattedMessage id="tr5.controls.more" />
          </StyledKebabLabel>
          <KebabMenuSeller
            vin={tradeDetails.vin}
            tradeId={tradeDetails.id}
            sellingNetworks={sellingNetworks}
            isOpenNetwork={network?.isOpenNetwork}
            tradeSummary={TradeDetails.asPendingTrade(
              tradeDetails,
              negotiationState
            )}
            isNoNegotiationsYet={
              negotiationState === NegotiationState.NO_NEGOTIATION
            }
            setPendingCardFooter={() => {}}
            isOmp={isOmp}
          />
        </StyledKebabWrapper>
      </PendingFooterContext.Provider>
    </StyledOverviewFooter>
  );
};

export default PendingFooter;
